import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import { categoriesURL, teamsURL } from "../../Hooks/URL";
import TeamProfile from "../../Template/Home/Teams/TeamProfile/TeamProfile";
import useDelete from "../../Hooks/useDelete";

function TeamProfilePage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const params = useParams();

  const [Open, setOpen] = useState(false);

  const [team, setTeam] = useState("");
  const { data, loading, error } = useFetch(`${teamsURL}/${params?.id}`);

  useEffect(() => {
    if (!loading && !error && data) {
      setTeam(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "teams", data: "" });
  }, []);

  const [go, setGo] = useState(false);
  const { state: deleteRes } = useDelete(
    `${teamsURL}/${params?.id}`,
    go,
    "teams",
    null,
    null,
    ""
  );

  return (
    <TeamProfile
      navigate={navigate}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      team={team}
      id={params?.id}
      setGo={setGo}
    />
  );
}

export default TeamProfilePage;
